// SCREENS-VIEWER: the calls the workspace makes to open and close a person's own session.
//
// Founder decisions (2026-10-28): agents start sessions; people join through Needs you or Watch.
// A person opens only a *login* browser on an account they own (or admins: any), from the
// Accounts tab, and closes it with Done. Admins may still open a bare desktop or browser.
//
// The login lease has its own route (`browserAccounts.login`, `purpose: "login"`): the account's
// owner or an admin; Done is `screens.stop`, which marks the owner's account live.
import type { Api } from "../../api/client";
import type { Lease } from "./screens-queries";

export type OpenKind = "desktop" | "browser";

/** Opens a login browser on an account, held and driven by me. */
export function openLoginLease(api: Api, co: string, accountId: string): Promise<Lease> {
  return api.client.browserAccounts.login({ params: { co, id: accountId } });
}

/** Done with my login browser (the account stays logged in on the stack's disk). */
export function releaseOwnLease(api: Api, co: string, leaseId: string): Promise<Lease> {
  return api.client.screens.stop({ params: { co, id: leaseId } });
}

/** Admins: a bare desktop or no-login browser. */
export function openBareLease(api: Api, co: string, kind: OpenKind): Promise<Lease> {
  return api.client.screens.open({ params: { co }, body: { kind } });
}
